import { render } from "./MessageListSection.vue?vue&type=template&id=20bd8f7f"
import script from "./MessageListSection.vue?vue&type=script&lang=js"
export * from "./MessageListSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__